export function getAuthProviderUrl() {
    const baseUrl = window._env_?.REACT_APP_AUTH_PROVIDER_URL;
    return baseUrl;
}

export function getAuthProviderLoginUrl() {
    const baseUrl = window._env_?.REACT_APP_AUTH_PROVIDER_URL;
    const orgId = window._env_?.REACT_APP_ORG_ID;
    // Remove trailing slash if present to ensure consistent URL formatting
    const cleanBaseUrl = baseUrl.replace(/\/$/, '');
    return `${cleanBaseUrl}/login?org_id=${orgId}`;
}